export const filtersManager = {
    openStateObservers: new Set(),
    filtersCountObservers: new Set(),

    callToOpen(popupParams: boolean) {
        try {
            this.openStateObservers.forEach((observer: Function) => observer(popupParams));
        } catch(err) {
            console.log(err);
        }
    },

    registerOpenStateObserver(observer: Function) {
        this.openStateObservers.add(observer);
    },

    unRegisterOpenStateObserver(observer: Function) {
        try {
            this.openStateObservers.delete(observer);
        } catch(err) {
            console.log(err);
        }
    },

    registerFiltersChangingObserver(observer: Function)  {
        this.filtersCountObservers.add(observer);
    },

    unRegisterFiltersChangingObserver(observer: Function)  {
        try {
            this.filtersCountObservers.delete(observer);
        } catch(err) {
            console.log(err);
        }
    },

    notifyFiltersChanged() {
        try {
            this.filtersCountObservers.forEach((observer: Function) => observer());
        } catch(err) {
            console.log(err);
        }
    },

    cleanObservers() {
        this.openStateObservers.clear();
        this.filtersCountObservers.clear();
    },
};
